import * as React from "react";
import { SVGProps } from "react";

const Aion = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 66 68" {...props}>
    <path fill="#1c1c1c" d="M33 68a8 8 0 1 0-8-8 8 8 0 0 0 8 8Z" />
    <path fill="#1c1c1c" d="M41.68 0h-17.4L0 67h14.7L33 16.55 51.26 67H66Z" />
  </svg>
);

export default Aion;
